import {load} from 'recaptcha-v3';
$('button.recaptcha').each(async function() {
    const me = $(this);

    me.data('recaptcha', await load(me.data('recaptchaKey'),{
        useRecaptchaNet: !!me.data('useAlternateUrl'),
    }));

    me.click(async function(event) {
        event.stopPropagation();
        event.preventDefault();

        const token = await me.data('recaptcha').execute(me.data('action'));

        const el = document.createElement('input');
        el.setAttribute('type', 'hidden');
        el.setAttribute('value', token);
        el.setAttribute('name', me.data('inputName'));

        me[0].form.appendChild(el);
        me[0].form.submit();
    })
});
